import { Button } from '@mantine/core';
import { MdUnarchive } from 'react-icons/md';
import { Message, MessageStatus } from '../types';

interface UnarchiveButtonProps {
    message: Message;
    onUnarchive: (message: Message) => void;
}

export const UnarchiveButton = ({ message, onUnarchive }: UnarchiveButtonProps) => {
    const handleClick = () => {
        onUnarchive({ ...message, status: MessageStatus.READ });
    };

    return (
        <Button
            leftSection={<MdUnarchive />}
            onClick={handleClick}
            variant="light"
        >
            Unarchive
        </Button>
    );
};
